import { gql } from '@apollo/client';

// ===== Preset Expenses =====

export const GET_PRESET_EXPENSES = gql`
  query GetPresetExpenses {
    presetExpenses {
      id
      name
      amount
      createdAt
      updatedAt
    }
  }
`;

export const GET_PRESET_EXPENSE = gql`
  query GetPresetExpense($id: String!) {
    presetExpense(id: $id) {
      id
      name
      amount
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PRESET_EXPENSE = gql`
  mutation CreatePresetExpense($input: CreatePresetExpenseInput!) {
    createPresetExpense(input: $input) {
      id
      name
      amount
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PRESET_EXPENSE = gql`
  mutation UpdatePresetExpense($id: String!, $input: UpdatePresetExpenseInput!) {
    updatePresetExpense(id: $id, input: $input) {
      id
      name
      amount
      updatedAt
    }
  }
`;

export const DELETE_PRESET_EXPENSE = gql`
  mutation DeletePresetExpense($id: String!) {
    deletePresetExpense(id: $id)
  }
`;

// ===== Hourly Employees =====

export const GET_HOURLY_EMPLOYEES = gql`
  query GetHourlyEmployees {
    hourlyEmployees {
      id
      name
      job
      hourlyRate
      isContractor
      createdAt
      updatedAt
    }
  }
`;

export const GET_HOURLY_EMPLOYEE = gql`
  query GetHourlyEmployee($id: String!) {
    hourlyEmployee(id: $id) {
      id
      name
      job
      hourlyRate
      isContractor
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_HOURLY_EMPLOYEE = gql`
  mutation CreateHourlyEmployee($input: CreateHourlyEmployeeInput!) {
    createHourlyEmployee(input: $input) {
      id
      name
      job
      hourlyRate
      isContractor
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_HOURLY_EMPLOYEE = gql`
  mutation UpdateHourlyEmployee($id: String!, $input: UpdateHourlyEmployeeInput!) {
    updateHourlyEmployee(id: $id, input: $input) {
      id
      name
      job
      hourlyRate
      isContractor
      updatedAt
    }
  }
`;

export const DELETE_HOURLY_EMPLOYEE = gql`
  mutation DeleteHourlyEmployee($id: String!) {
    deleteHourlyEmployee(id: $id)
  }
`;

// ===== Work Order Billing Settings =====

export const GET_WORK_ORDER_BILLING_MARKUP = gql`
  query GetWorkOrderBillingMarkup {
    workOrderBillingMarkupPercentage
  }
`;

export const SET_WORK_ORDER_BILLING_MARKUP = gql`
  mutation SetWorkOrderBillingMarkup($percentage: Float!) {
    setWorkOrderBillingMarkupPercentage(percentage: $percentage)
  }
`;

export const GET_SERVICE_CHARGE_HOURLY = gql`
  query GetServiceChargeHourly {
    serviceChargeHourlyRate
  }
`;

export const SET_SERVICE_CHARGE_HOURLY = gql`
  mutation SetServiceChargeHourly($rate: Float!) {
    setServiceChargeHourlyRate(rate: $rate)
  }
`;

export const GET_WORK_ORDER_SERVICE_CHARGE = gql`
  query GetWorkOrderServiceCharge {
    workOrderServiceCharge
  }
`;

export const SET_WORK_ORDER_SERVICE_CHARGE = gql`
  mutation SetWorkOrderServiceCharge($amount: Float!) {
    setWorkOrderServiceCharge(amount: $amount)
  }
`;

